import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import SelectInputWithLabelT from '@components/tailwind-components/Input/SelectInputWithLabelT';
import type React from 'react';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { TFacebookSettings } from '../../../../../interfaces/TFacebook';

type Props = {
  name: string;
  control: Control<TFacebookSettings>;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const FacebookCallToAction: React.FC<Props> = ({ name, control }) => {
  const { t } = useTranslation();
  return (
    <div className='flex-grow'>
      <SelectInputWithLabelT
        field={`${name}.type` as any}
        label={t('settings.facebook.call-to-action.type')}
        control={control}
        values={[
          { value: 'postback', description: 'Button' },
          { value: 'web_url', description: 'URL' },
        ]}
      />

      <InputWithLabelT
        type='text'
        field={`${name}.title` as any}
        placeholder={t('settings.facebook.call-to-action.title')}
        label={t('settings.facebook.call-to-action.title')}
        control={control}
      />

      <InputWithLabelT
        type='text'
        field={`${name}.url` as any}
        placeholder={t('settings.facebook.call-to-action.url')}
        label={t('settings.facebook.call-to-action.url')}
        control={control}
      />

      <InputWithLabelT
        type='text'
        field={`${name}.payload` as any}
        placeholder={t('settings.facebook.call-to-action.payload')}
        label={t('settings.facebook.call-to-action.payload')}
        control={control}
      />
    </div>
  );
};

export default FacebookCallToAction;
